import { Component, OnInit } from '@angular/core';
import { FAQ, FAQClient } from 'src/app/services/apis/web-api-client';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  questions: FAQ[] = []
  isLoading: boolean = true;
  constructor(
    private readonly faqClient: FAQClient
  ) { }

  ngOnInit() {
    this.faqClient.getAll().subscribe((response) => {
      this.questions = response;
      this.isLoading = false;
    })
  }

}
